<template>
  <div class="details-box">
    <div class="d-flex justify-space-between top-details">
      <div class="d-flex align-center">
        <div class="f-field">
          <div class="f-label">BOOKING ID</div>
          <div class="value">
            <span class="pending-txt" v-if="isPending">PENDING</span>
            <span v-else>{{details.bookingId}}</span>
          </div>
        </div>
        <div class="f-field">
          <div class="f-label">BOOKED</div>
          <div class="value">{{details.bookedDate}}</div>
        </div>
        <div class="f-field">
          <div class="f-label">AIRLINE PNR</div>
          <div class="value">
            <span class="pending-txt" v-if="isPending && !details.airlinePNR">PENDING</span>
            <span v-else>{{details.airlinePNR}}</span>
          </div>
        </div>
        <div class="f-field">
          <div class="value"><span :class="['refund-label', {non:!details.isRefundable}]">{{details.isRefundable ? 'REFUNDABLE' : 'NON-REFUNDABLE'}}</span></div>
        </div>
      </div>

      <div class="action-box">
        <div class="button cta primary small" @click="sendEmail">
          <span>SEND EMAIL</span>
        </div>
        <div :class="['button cta small', details.isRefundable ? 'error' : 'secondary', {disabled:!details.isRefundable}]" @click="getCancelFee(false)" v-if="details.status === 'UPCOMING'">
          <span>CANCEL FLIGHT</span>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="left-box">
        <div class="journey">
          <div class="f-label table-head">
            JOURNEY DETAILS
            <span v-if="hasReturnTrip">- FIRST TRIP</span>
          </div>
          <table cellspacing="0">
            <tr class="head" v-if="hasRsvp(rsvp1)">
              <td>Service</td>
              <td>Pickup</td>
              <td>Dropoff</td>
              <td align="right"><div :class="['status', rsvp1.status]" >{{rsvp1.status}}</div></td>
            </tr>
            <tr v-if="hasRsvp(rsvp1)">
              <td>
                <div class="service">{{rsvp1.service}}</div>
                <a :href="`#/reservation/${rsvp1.id}`" target="_blank" class="rsvp-link">RSVP {{rsvp1.id}}</a>
              </td>
              <td class="loc">
                <b>{{rsvp1.pickup ? rsvp1.pickup.title : ''}}</b>
                <div class="date">
                  {{rsvp1.pickupDate}}
                  <span class="local-tz">Local</span>
                </div>
                <div class="date">
                  {{rsvp1.pickupDateLA}}
                  <span class="local-tz la">Pacific Time</span>
                </div>
              </td>
              <td class="loc">
                <b>{{rsvp1.dropoff ? rsvp1.dropoff.airportCode : ''}}</b>
              </td>
              <td class="td-action">
                <i class="fas fa-ellipsis-v fa-2x" @click="showOptions(rsvp1, 'rsvp1')"></i>
              </td>
            </tr>

            <tr class="head">
              <td>Flight</td>
              <td>Departing</td>
              <td colspan="2">Arriving</td>
            </tr>
            <tr v-for="(flight, i) in details.flights.oneway" :key="i" :class="{'flight-tr': i + 1 < details.flights.oneway.length}">
              <td class="flight-name">
                <div>{{flight.flightName}}</div>
                <b>{{flight.flightCode}} - {{flight.flightNo}}</b>
              </td>
              <td class="loc">
                <b>{{flight.origin.code}}</b>
                <div>{{flight.origin.name}}</div>
                <div class="date">
                  {{flight.origin.date}}
                  <span class="local-tz">Local</span>
                </div>
                <div class="date">
                  {{flight.origin.dateLA}}
                  <span class="local-tz la">Pacific Time</span>
                </div>
              </td>
              <td class="loc" colspan="2">
                <b>{{flight.destination.code}}</b>
                <div>{{flight.destination.name}}</div>
                <div class="date">
                  {{flight.destination.date}}
                  <span class="local-tz">Local</span>
                </div>
                <div class="date">
                  {{flight.destination.dateLA}}
                  <span class="local-tz la">Pacific Time</span>
                </div>
              </td>
            </tr>

            <tr class="head" v-if="hasRsvp(rsvp2)">
              <td>Service</td>
              <td>Pickup</td>
              <td>Dropoff</td>
              <td align="right"><div :class="['status', rsvp2.status]" >{{rsvp2.status}}</div></td>
            </tr>
            <tr v-if="hasRsvp(rsvp2)">
              <td>
                <div class="service">{{rsvp2.service}}</div>
                <a :href="`#/reservation/${rsvp2.id}`" target="_blank" class="rsvp-link">RSVP {{rsvp2.id}}</a>
              </td>
              <td class="loc">
                <b>{{rsvp2.pickup ? rsvp2.pickup.airportCode : ''}}</b>
                <div class="date">
                  {{rsvp2.pickupDate}}
                  <span class="local-tz">Local</span>
                </div>
                <div class="date">
                  {{rsvp2.pickupDateLA}}
                  <span class="local-tz la">Pacific Time</span>
                </div>
              </td>
              <td class="loc">
                <b>{{rsvp2.dropoff ? rsvp2.dropoff.title : ''}}</b>
              </td>
              <td class="td-action">
                <i class="fas fa-ellipsis-v fa-2x" @click="showOptions(rsvp2, 'rsvp2')"></i>
              </td>
            </tr>
          </table>
        </div>

        <div class="journey" v-if="hasReturnTrip">
          <div class="f-label table-head">JOURNEY DETAILS - RETURN TRIP</div>
          <table cellspacing="0">
            <tr class="head" v-if="hasRsvp(rsvp3)">
              <td>Service</td>
              <td>Pickup</td>
              <td>Dropoff</td>
              <td align="right"><div :class="['status', rsvp3.status]" >{{rsvp3.status}}</div></td>
            </tr>
            <tr v-if="hasRsvp(rsvp3)">
              <td>
                <div class="service">{{rsvp3.service}}</div>
                <a :href="`#/reservation/${rsvp3.id}`" target="_blank" class="rsvp-link">RSVP {{rsvp3.id}}</a>
              </td>
              <td class="loc">
                <b>{{rsvp3.pickup ? rsvp3.pickup.title : ''}}</b>
                <div class="date">
                  {{rsvp3.pickupDate}}
                  <span class="local-tz">Local</span>
                </div>
                <div class="date">
                  {{rsvp3.pickupDateLA}}
                  <span class="local-tz la">Pacific Time</span>
                </div>
              </td>
              <td class="loc">
                <b>{{rsvp3.dropoff ? rsvp3.dropoff.airportCode : ''}}</b>
              </td>
              <td class="td-action">
                <i class="fas fa-ellipsis-v fa-2x" @click="showOptions(rsvp3, 'rsvp3')"></i>
              </td>
            </tr>
            <tr class="head">
              <td>Flight</td>
              <td>Departing</td>
              <td colspan="2">Arriving</td>
            </tr>
            <tr v-for="(flight, i) in details.flights.return" :key="i" :class="{'flight-tr': i + 1 < details.flights.return.length}">
              <td class="flight-name">
                <div>{{flight.flightName}}</div>
                <b>{{flight.flightCode}} - {{flight.flightNo}}</b>
              </td>
              <td class="loc">
                <b>{{flight.origin.code}}</b>
                <div>{{flight.origin.name}}</div>
                <div class="date">
                  {{flight.origin.date}}
                  <span class="local-tz">Local</span>
                </div>
                <div class="date">
                  {{flight.origin.dateLA}}
                  <span class="local-tz la">Pacific Time</span>
                </div>
              </td>
              <td class="loc" colspan="2">
                <b>{{flight.destination.code}}</b>
                <div>{{flight.destination.name}}</div>
                <div class="date">
                  {{flight.destination.date}}
                  <span class="local-tz">Local</span>
                </div>
                <div class="date">
                  {{flight.destination.dateLA}}
                  <span class="local-tz la">Pacific Time</span>
                </div>
              </td>
            </tr>
            <tr class="head" v-if="hasRsvp(rsvp4)">
              <td>Service</td>
              <td>Pickup</td>
              <td>Dropoff</td>
              <td align="right"><div :class="['status', rsvp4.status]" >{{rsvp4.status}}</div></td>
            </tr>
            <tr v-if="hasRsvp(rsvp4)">
              <td>
                <div class="service">{{rsvp4.service}}</div>
                <a :href="`#/reservation/${rsvp4.id}`" target="_blank" class="rsvp-link">RSVP {{rsvp4.id}}</a>
              </td>
              <td class="loc">
                <b>{{rsvp4.pickup ? rsvp4.pickup.airportCode : ''}}</b>
                <div class="date">
                  {{rsvp4.pickupDate}}
                  <span class="local-tz">Local</span>
                </div>
                <div class="date">
                  {{rsvp4.pickupDateLA}}
                  <span class="local-tz la">Pacific Time</span>
                </div>
              </td>
              <td class="loc">
                <b>{{rsvp4.dropoff ? rsvp4.dropoff.title : ''}}</b>
              </td>
              <td class="td-action">
                <i class="fas fa-ellipsis-v fa-2x" @click="showOptions(rsvp4, 'rsvp4')"></i>
              </td>
            </tr>
          </table>
        </div>

        <div class="pax">
          <div class="f-label table-head">PASSENGER</div>
          <table cellspacing="0">
            <thead>
              <th>Name</th>
              <th>Ticket ID</th>
              <th>Ticket Number</th>
            </thead>
            <tr v-for="(p, i) in details.pax" :key="i" v-if="!isPending">
              <td>{{p.firstName}} {{p.lastName}}</td>
              <td>{{p.ticketId}}</td>
              <td>{{p.ticketNo}}</td>
            </tr>
            <tr v-if="isPending">
              <td><span class="pending-txt">PENDING</span></td>
              <td><span class="pending-txt">PENDING</span></td>
              <td><span class="pending-txt">PENDING</span></td>
            </tr>
          </table>
        </div>
      </div>

      <div class="right-box">
        <div class="payment-box">
          <div class="f-label table-head">PAYMENT BREAKDOWN</div>
          <table cellspacing="0">
            <tr>
              <td>Air Fare and Taxes</td>
              <td>${{priceFormat(details.airFareTotal)}}</td>
            </tr>
            <tr v-if="hasRsvp(rsvp1)">
              <td>
                <span v-if="hasReturnTrip">Leg 1:</span>
                {{shortenLoc(rsvp1.pickup)}} to {{shortenLoc(rsvp1.dropoff)}}
              </td>
              <td>${{priceFormat(rsvp1.payment)}}</td>
            </tr>
            <tr v-if="hasRsvp(rsvp2)">
              <td>
                <span v-if="hasReturnTrip">Leg 2:</span>
                {{shortenLoc(rsvp2.pickup)}} to {{shortenLoc(rsvp2.dropoff)}}
              </td>
              <td>${{priceFormat(rsvp2.payment)}}</td>
            </tr>
            <tr v-if="hasReturnTrip && hasRsvp(rsvp3)">
              <td>
                Leg 3:
                {{shortenLoc(rsvp3.pickup)}} to {{shortenLoc(rsvp3.dropoff)}}
              </td>
              <td>${{priceFormat(rsvp3.payment)}}</td>
            </tr>
            <tr v-if="hasReturnTrip && hasRsvp(rsvp4)">
              <td>
                Leg 4:
                {{shortenLoc(rsvp4.pickup)}} to {{shortenLoc(rsvp4.dropoff)}}
              </td>
              <td>${{priceFormat(rsvp4.payment)}}</td>
            </tr>
            <tr class="total">
              <td>TOTAL</td>
              <td>${{priceFormat(totalPayment)}}</td>
            </tr>
          </table>
        </div>

        <div class="map-box">
          <fmap ref="refmap"></fmap>
        </div>
      </div>
    </div>

    <div :class="['lr-modal', {'hide': !showCxlConfirm}]" @click.self="showCxlConfirm = false">
      <div class="lr-box">
        Are you sure you want to cancel this flight?

        <div class="cxl-fee-box">
          <span>
            The customer will have to pay a cancellaton fee of 
            <b>${{currentFlightFee}}</b>. 
            Do you want to charge the cancellation fee?
          </span>
          <div class="fee-breakdown">
            Flight Fee: <b>${{flightAction.cxlFee.flight}}</b>
            <div v-if="rsvp1.status === 'upcoming'">RSVP 1 Fee: <b>${{flightAction.cxlFee.rsvp1}}</b></div>
            <div v-if="rsvp2.status === 'upcoming'">RSVP 2 Fee: <b>${{flightAction.cxlFee.rsvp2}}</b></div>
            <div v-if="hasReturnTrip">
              <div v-if="rsvp3.status === 'upcoming'">RSVP 3 Fee: <b>${{flightAction.cxlFee.rsvp3}}</b></div>
              <div v-if="rsvp4.status === 'upcoming'">RSVP 4 Fee: <b>${{flightAction.cxlFee.rsvp4}}</b></div>
            </div>
          </div>
          <div class="d-flex flex-column">
            <label>
              <input type="radio" name="cancelFee" value="1" v-model="flightAction.charge">
              Yes, refund <b>${{priceFormat((totalPayment - currentFlightFee).toFixed(2))}}</b> only
            </label>
            <label>
              <input type="radio" name="cancelFee" value="0" v-model="flightAction.charge">
              No, refund full amount of <b>${{priceFormat(totalPayment.toFixed(2))}}</b>
            </label>
          </div>
        </div>

        <ul class="check-list">
          <li>
            <label>
              <input type="checkbox" v-model="cancelAllGround" />
              Cancel all ground RSVP
            </label>
          </li>
          <li>
            <label>
              <input type="checkbox" v-model="notifyUser" />
              Notify the user
            </label>
          </li>
        </ul>
        <a class="button cta xsmall primary block" @click="cxlFLight">
          Yes, cancel this flight
        </a>
        <a class="button cta xsmall secondary block" @click="showCxlConfirm = false">
          No, i change my mind
        </a>
      </div>
    </div>

    <div :class="['lr2-modal', {'hide': !rsvpAction.show}]" @click.self="rsvpAction.show = false">
      <div class="lr2-box rsvp-modal" v-if="rsvpAction.confirm">
        <div v-if="rsvpAction.type === 'cancel'">
          Are you sure you want to cancel <b>RSVP {{rsvpAction.data.id}}</b>?

          <div class="cxl-fee-box">
            <span>
              The customer will have to pay a cancellaton fee of 
              <b>${{flightAction.cxlFee[rsvpAction.target]}}</b>. 
              Do you want to charge the cancellation fee?
            </span>
            <div class="d-flex justify-space-around align-center">
              <label>
                <input type="radio" name="cancelFee" value="1" v-model="rsvpAction.charge">
                Yes
              </label>
              <label>
                <input type="radio" name="cancelFee" value="0" v-model="rsvpAction.charge">
                No
              </label>
            </div>
          </div>
        </div>
        <!-- <div v-if="rsvpAction.type === 'refund'">
          Confirm refund <b>RSVP {{rsvpAction.data.id}}</b>?
          <div class="cxl-fee-box">
            <span>
              The customer will have to pay a cancellaton fee of 
              <b>${{rsvpAction.cxlFee.toFixed(2)}}</b>. 
              Do you want to charge the cancellation fee?
            </span>
            <div class="d-flex justify-space-around align-center">
              <label>
                <input type="radio" name="cancelFee" value="1" v-model="rsvpAction.charge">
                Yes
              </label>
              <label>
                <input type="radio" name="cancelFee" value="0" v-model="rsvpAction.charge">
                No
              </label>
            </div>
          </div>
        </div> -->
        <div class="actions">
          <div class="button cta primary block small" @click="proccessAction(rsvpAction.data.id)">
            <span v-if="rsvpAction.type === 'cancel'">Yes, cancel this RSVP</span>
            <span v-if="rsvpAction.type === 'refund'">Yes, refund this RSVP</span>
          </div>
          <div class="button cta secondary block small" @click="rsvpAction.show = false">
            <span v-if="rsvpAction.type === 'cancel'">No, I change my mind</span>
            <span v-if="rsvpAction.type === 'refund'">Cancel Refund</span>
          </div>
        </div>
      </div>

      <div class="lr2-box rsvp-modal" v-else>
        <div class="d-flex align-center justify-space-between">
          <div class="id">RSVP {{rsvpAction.data.id}}</div>
          <div :class="['status', rsvpAction.data.status]">{{rsvpAction.data.status}}</div>
        </div>
        <div class="service">{{rsvpAction.data.service}}</div>
        <div class="loc">
          <div class="label">PICKUP</div>
          <div class="val">{{rsvpAction.data.pickup ? rsvpAction.data.pickup.title : ''}}</div>
        </div>
        <div class="loc">
          <div class="label">DROPOFF</div>
          <div class="val">{{rsvpAction.data.dropoff ? rsvpAction.data.dropoff.title : ''}}</div>
        </div>

        <div class="actions">
          <div class="button cta block small error" @click="showConfirm('cancel')" v-if="rsvpAction.data.status === 'upcoming'">
            <span>CANCEL RSVP</span>
          </div>
          <!-- <div class="button cta block small primary" @click="showConfirm('refund')" v-if="['canceled', 'complete'].indexOf(rsvpAction.data.status) > -1">
            <span>REFUND RSVP</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
// import moment from 'moment-timezone'
import fmap from './fmap'

export default {
  name: 'flight-details',
  components: { fmap },
  props: [ 'doneAllLoading' ],
  data () {
    return {
      showCxlConfirm: false,
      cancelAllGround: true,
      notifyUser: true,
      rsvpAction: {
        show: false,
        confirm: false,
        data: {},
        type: '',
        target: '',
        cxlFee: 0,
        charge: 1
      },
      flightAction: {
        cxlFee: {
          flight: 0,
          rsvp1: 0,
          rsvp2: 0,
          rsvp3: 0,
          rsvp4: 0,
          total: 0
        },
        charge: 1,
        lastId: 0
      }
    }
  },
  computed: {
    id () { return this.$route.params.id },
    flight () { return this.$store.state.flightDetails },
    details () { return this.flight.details },
    hasReturnTrip () { return this.details.roundtripId },
    rsvp1 () { return this.flight.rsvp1 },
    rsvp2 () { return this.flight.rsvp2 },
    rsvp3 () { return this.flight.rsvp3 },
    rsvp4 () { return this.flight.rsvp4 },
    totalPayment () {
      let air = this.details.airFareTotal
      let land = 0
      if (this.hasRsvp(this.rsvp1)) land += parseFloat(this.rsvp1.payment)
      if (this.hasRsvp(this.rsvp2)) land += parseFloat(this.rsvp2.payment)
      if (this.hasReturnTrip) {
        if (this.hasRsvp(this.rsvp3)) land += parseFloat(this.rsvp3.payment)
        if (this.hasRsvp(this.rsvp4)) land += parseFloat(this.rsvp4.payment)
      }
      // parseFloat(this.rsvp1.payment) + parseFloat(this.rsvp2.payment)
      // if (this.hasReturnTrip) land = land * 2
      return air + land
    },
    currentFlightFee () {
      let total = this.flightAction.cxlFee.total
      if (this.rsvp1.status !== 'upcoming') total = total - parseFloat(this.flightAction.cxlFee.rsvp1)
      if (this.rsvp2.status !== 'upcoming') total = total - parseFloat(this.flightAction.cxlFee.rsvp2)
      if (this.hasReturnTrip) {
        if (this.rsvp3.status !== 'upcoming') total = total - parseFloat(this.flightAction.cxlFee.rsvp3)
        if (this.rsvp4.status !== 'upcoming') total = total - parseFloat(this.flightAction.cxlFee.rsvp4)
      }
      return parseFloat(total.toFixed(2))
    },
    isPending () { return this.details.isPending }
  },
  methods: {
    initMap () {
      if (this.$refs.refmap.initPoints()) {
        this.$refs.refmap.initPoints()
      }
    },
    priceFormat (data) {
      return parseFloat(data).toLocaleString('en-US', {minimumFractionDigits: 2})
    },
    shortenLoc (data) {
      if (!data) return ''
      if (data.geofenceType === 'airport') return data.airportCode
      return `${data.city}, ${data.state}`
    },
    sendEmail () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      try {
        self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/email`, {
          token: self.$store.state.session.sessionToken,
          d2dId: self.id,
        }, res => {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          if (res.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            })
            return
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `Email sent.`
          })
        })
      } catch (err) {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        self.$store.commit('global/setAlertData', {
          show: true,
          message: err
        })
      }
    },
    getCancelFee (forRsvp, dat) {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/cancelfee`, {
        token: self.$store.state.session.sessionToken,
        d2dId: self.id,
      }, res => {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        self.flightAction.lastId = self.id
        self.flightAction.cxlFee.total = res.amount ? parseFloat(res.amount.toFixed(2)) : 0
        self.flightAction.cxlFee.flight = res.flight ? parseFloat(res.flight.toFixed(2)) : 0
        self.flightAction.cxlFee.rsvp1 = res.rsvp[self.rsvp1.id] ? parseFloat(res.rsvp[self.rsvp1.id].toFixed(2)) : 0
        self.flightAction.cxlFee.rsvp2 = res.rsvp[self.rsvp2.id] ? parseFloat(res.rsvp[self.rsvp2.id].toFixed(2)) : 0
        if (self.hasReturnTrip) {
          self.flightAction.cxlFee.rsvp3 = res.rsvp[self.rsvp3.id] ? parseFloat(res.rsvp[self.rsvp3.id].toFixed(2)) : 0
          self.flightAction.cxlFee.rsvp4 = res.rsvp[self.rsvp4.id] ? parseFloat(res.rsvp[self.rsvp4.id].toFixed(2)) : 0
        }
        if (forRsvp) {
          self.rsvpAction.show = true
          self.rsvpAction.confirm = false
          self.rsvpAction.data = dat.data
          self.rsvpAction.target = dat.target
          return
        }
        self.showCxlConfirm = true
      })
    },
    cxlFLight () {
      let self = this
      self.showCxlConfirm = false
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      try {
        let param = {
          token: self.$store.state.session.sessionToken,
          d2dId: self.id,
          cancelGround: self.cancelAllGround,
          email: self.notifyUser,
          refundAmount: self.totalPayment
        }
        if (self.flightAction.charge == 1) {
          let cxlFee = self.flightAction.cxlFee.total
          if (self.rsvp1.status !== 'upcoming') cxlFee = cxlFee - parseFloat(self.flightAction.cxlFee.rsvp1)
          if (self.rsvp2.status !== 'upcoming') cxlFee = cxlFee - parseFloat(self.flightAction.cxlFee.rsvp2)
          if (self.hasReturnTrip) {
            if (self.rsvp3.status !== 'upcoming') cxlFee = cxlFee - parseFloat(self.flightAction.cxlFee.rsvp3)
            if (self.rsvp4.status !== 'upcoming') cxlFee = cxlFee - parseFloat(self.flightAction.cxlFee.rsvp4)
          }
          param.refundAmount = parseFloat((self.totalPayment - cxlFee).toFixed(2))
        }
        self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/cancel`, param, res => {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          if (res.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            })
            return
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `Flight #${self.id} has been cancelled.`
          })
          self.$router.push('/flights')
        })
      } catch (err) {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        self.$store.commit('global/setAlertData', {show: true, message: err})
      }
    },
    showOptions (data, target) {
      if (this.flightAction.lastId !== this.id) {
        this.getCancelFee(true,{data: data, target: target})
        return
      }
      this.rsvpAction.show = true
      this.rsvpAction.confirm = false
      this.rsvpAction.data = data
      this.rsvpAction.target = target
    },
    showConfirm (type) {
      this.rsvpAction.type = type
      if (type === 'cancel') {
        if (this.rsvpAction.data.status !== 'upcoming') return
        this.rsvpAction.confirm = true
      }
      if (type === 'refund') {
        this.getCxlFee(this.rsvpAction.data.id)
      }
    },
    proccessAction (id) {
      if (this.rsvpAction.type === 'cancel') this.cancelRsvp(id)
      if (this.rsvpAction.type === 'refund') this.refundRsvp(id)
    },
    cancelRsvp (rsvpId) {
      let self = this
      self.rsvpAction.show = false
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      let amount = parseFloat(self[self.rsvpAction.target].payment)
      if (self.rsvpAction.charge == 1) {
        amount = amount - self.flightAction.cxlFee[self.rsvpAction.target]
      }
      self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/rsvp/cancel`, {
        token: self.$store.state.session.sessionToken,
        d2dId: self.id,
        rsvpId: rsvpId,
        amount: amount,
        order: 'createTime',
        desc: true
      }, res => {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: `Succesfully canceled RSVP ${rsvpId}.`
        })
        self.$store.commit('flightDetails/updateRsvpStatus', {
          target: self.rsvpAction.target,
          val: 'canceled'
        })
      })
    },
    getCxlFee (rsvpId) {
      let self = this
      self.rsvpAction.show = false
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      self.$sdk.get(`/admin/rsvp/${rsvpId}/fee`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        self.rsvpAction.show = true
        self.rsvpAction.confirm = true
        self.rsvpAction.cxlFee = parseFloat(r.amount)
      })
    },
    refundRsvp (rsvpId) {
      let self = this
      self.rsvpAction.show = false
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      let data = {
        token: self.$store.state.session.sessionToken,
        d2dId: self.id,
        rsvpId: rsvpId
      }
      if (self.rsvpAction.charge == 1) {
        data.amount = parseFloat(self[self.rsvpAction.target].payment) - self.rsvpAction.cxlFee
      }
      self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/rsvp/refund`, data, res => {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        self.$store.commit('global/setAlertData', {
          show: true,
          message: `Succesfully refunded RSVP ${rsvpId}.`
        })
      })
    },
    hasRsvp (x) {
      return Object.keys(x).length
    }
  },
  watch: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
.details-box{
  background: #fbfbfb;
  border-radius: 2px;
  border-top: 1px solid #ddd;
  box-shadow: 1px 1px 2px rgba(0,0,0, .1);
}
.top-details{
  padding: 20px 10px 0;

  .f-field{
    padding-left: 10px;
  }
  .refund-label{
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    padding: 5px 10px;
    background: #41b430;
    color: #fff;
    border-radius: 4px;
    letter-spacing: .6px;

    &.non{
      background: #ccc;
      color: #333;
    }
  }
}
.pending-txt{
  font-weight: 600;
  color: #f00;
}
.left-box{
  width: 65%;
  padding: 10px 0 20px;
}
.f-field{
  padding: 0 20px;
  margin-bottom: 10px;

  .value{
    font-weight: 600;
    font-size: 18px;
  }
}
.f-label{
  font-size: 11px;
  color: #888;
  line-height: 1;
  font-weight: 600;
}
.table-head{
  background: #333;
  color: #fff;
  margin-bottom: 0!important;
  padding: 10px;
  letter-spacing: .6px;
}
.journey{
  margin: 10px 20px 25px;

  .f-label{
    margin-bottom: 5px;
  }
  table{
    border: 1px solid #999;
    width: 100%;
    background: #fff;

    .head{
      padding: 3px 10px;
      font-weight: 600;
      line-height: 20px;
      background: #eaeaea;
      color: #333;
      font-size: 13px;
    }
    td{
      vertical-align: top;
      padding: 10px;

      &:nth-child(1){
        min-width: 120px;
      }
    }
    tr:nth-child(even):not(.head) td{
      background: #f7f7f7;
    }
  }
  .rsvp-link{
    font-weight: 600;
    font-size: 13px;
    line-height: 1;
    margin: 7px 0;
    display: block;
  }
  .service{
    font-weight: 600;
    font-size: 18px;
    line-height: 1;
  }
  .flight-tr{
    td{
      border-bottom: 1px solid #ccc;
    }
  }
  .flight-name{
    div{
      line-height: 1;
      margin-bottom: 1px;
      font-size: 15px;
      color: #777;
    }
    b{
      font-size: 18px;
    }
  }
  .loc{
    max-width: 400px;
    b{
      font-size: 16x;
      margin-bottom: 2px;
    }
    div{
      line-height: 1;
      font-size: 14px;
    }
    .date{
      margin-top: 5px;
      color: #777;

      .local-tz{
        background: #ccc;
        color: #fff;
        letter-spacing: .7px;
        display: inline-block;
        border-radius: 3px;
        font-size: 12.5px;
        padding: 4px;
        line-height: 1;
        margin-left: 4px;
        vertical-align: 1px;

        &.la{
          background: #76d3ff;
        }
      }
    }
  }
  .td-action{
    width: 100px;
    text-align: right;
    vertical-align: middle;

    i{
      cursor: pointer;
      color: #0D79F2
    }
  }
}
.pax{
  margin: 0 20px 15px;

  .f-label{
    margin-bottom: 5px;
  }
  table{
    width: 100%;
    border: 1px solid  #999;
    text-align: left;

    th{
      padding: 10px;
      background: #eaeaea;
      color: #333;
      font-size: 13px;
      line-height: 1;
    }
    td{
      padding: 10px;
    }
    th:last-child, td:last-child{
      border-right: none;
    }
  }
}

.right-box{
  width: 35%;
  // max-width: 600px;
  padding: 20px 10px;
}
.payment-box{
  margin-bottom: 20px;
  .f-label{
    margin-bottom: 5px;
  }
  table{
    width: 100%;
    border: 1px solid #999;

    td{
      padding: 5px 10px;
      border-bottom: 1px solid #ccc;
    }
    td:nth-child(1){
      color: #333;
      font-weight: 600;
      font-size: 13px;
      border-right: 1px solid #ccc;
    }
    td:nth-child(2){
      font-weight: 600;
      font-size: 18px;
      text-align: right;
      color: #444;
    }
    .total{
      td{
        background: #f3f3f3;
      }
      td:nth-child(2){
        color: #111;
        font-size: 21px;
      }
    }
  }
}

.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.05s ease;
  -moz-transition: all 0.05s ease;
  -o-transition: all 0.05s ease;
  transition: all 0.05s ease;

  .lr-box {
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 3px 3px 2px rgba(0,0,0, .3);
    text-align: center;
    min-width: 200px;
    max-width: 420px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  &.hide {
    z-index: -1;
    opacity: 0;

    .lr-box{
      transform: scale(90%) translateY(30px);
    }
  }
  .cxl-fee-box{
    text-align: left;
    margin-top: 20px;

    .d-flex{
      margin-top: 5px;

      b{
        margin-left: 5px;
      }
    }
  }
  .fee-breakdown{
    margin: 10px 0;
    padding: 0 20px;
    line-height: 1.5;

    b{
      margin-left: 3px;
    }
  }
  a{
    margin-top: 10px;
  }
}
.check-list{
  margin: 15px 0;
  padding: 0;
  border: 1px solid #ccc;
  list-style: none;
  text-align: left;

  li{
    border-bottom: 1px solid #ccc;
    padding: 7px 5px;
    font-size: 14px;
    background: #f9f9f9;

    &:last-child{
      border-bottom: none;
    }
    &:hover{
      background: #fff;
    }
  }
  label{
    display: block;
    cursor: pointer;
  }
  input{
    cursor: pointer;
    width: auto;
    vertical-align: -1px;
    margin: 0 5px 0 0;
    display: inline-block;
  }
}

.lr2-box{
  width: 100%;
  max-width: 400px;
}
.rsvp-modal{
  text-align: left;

  .id{
    font-size: 21px;
    font-weight: 600;
    color: #365074;
    line-height: 1;
  }
  .service{
    margin-bottom: 10px;
  }
  .loc{
    margin-bottom: 10px;
    line-height: 1;

    .label{
      font-size: 11px;
      color: #aaa;
      font-weight: 600;
      letter-spacing: .6px;
      margin-bottom: 2px;
    }
    .val{
      font-weight: 600;
      font-size: 15px;
    }
  }
  .actions{
    margin-top: 30px;

    .button:first-child{
      margin-bottom: 10px;
    }
  }
}
.cxl-fee-box{
  padding: 10px 20px;
  font-size: 13px;
  background: #f4c6c6;
  border: 1px solid #e75e5e;
  border-radius: 4px;
  margin: 10px 0 0;
  line-height: 140%;

  input{
    width: auto;
    display: inline-block;
    margin: 10px 3px 0 0;
    vertical-align: -2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FlightDetails/details.vue